// source: Msg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.ChatMessage', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.ClientType', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.EvaluateType', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.Knowledge', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.LoginMessage', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.MessageData', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.MessageDataType', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.MessageType', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.ServiceStatus', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.SessionType', null, global);
goog.exportSymbol('proto.com.netty.server.im.protobuf.gencode.UserType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.netty.server.im.protobuf.gencode.LoginMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.netty.server.im.protobuf.gencode.LoginMessage.displayName = 'proto.com.netty.server.im.protobuf.gencode.LoginMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.netty.server.im.protobuf.gencode.Knowledge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.netty.server.im.protobuf.gencode.Knowledge.displayName = 'proto.com.netty.server.im.protobuf.gencode.Knowledge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.netty.server.im.protobuf.gencode.ChatMessage.repeatedFields_, null);
};
goog.inherits(proto.com.netty.server.im.protobuf.gencode.ChatMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.netty.server.im.protobuf.gencode.ChatMessage.displayName = 'proto.com.netty.server.im.protobuf.gencode.ChatMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.netty.server.im.protobuf.gencode.MessageData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.netty.server.im.protobuf.gencode.MessageData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.netty.server.im.protobuf.gencode.MessageData.displayName = 'proto.com.netty.server.im.protobuf.gencode.MessageData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.com.netty.server.im.protobuf.gencode.LoginMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    companyid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    bizcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    account: jspb.Message.getFieldWithDefault(msg, 5, ""),
    customerid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    usertoken: jspb.Message.getFieldWithDefault(msg, 7, ""),
    name: jspb.Message.getFieldWithDefault(msg, 8, ""),
    usertype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    locale: jspb.Message.getFieldWithDefault(msg, 10, ""),
    userip: jspb.Message.getFieldWithDefault(msg, 11, ""),
    useraddress: jspb.Message.getFieldWithDefault(msg, 12, ""),
    usersource: jspb.Message.getFieldWithDefault(msg, 13, ""),
    clienttype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    clientdetail: jspb.Message.getFieldWithDefault(msg, 15, ""),
    accessaddress: jspb.Message.getFieldWithDefault(msg, 16, ""),
    businesslimit: jspb.Message.getFieldWithDefault(msg, 17, 0),
    servicestatus: jspb.Message.getFieldWithDefault(msg, 18, 0),
    sceneid: jspb.Message.getFieldWithDefault(msg, 19, 0),
    sceneparamMap: (f = msg.getSceneparamMap()) ? f.toObject(includeInstance, undefined) : [],
    extend: jspb.Message.getFieldWithDefault(msg, 21, ""),
    sessiontype: jspb.Message.getFieldWithDefault(msg, 22, 0),
    bizstep: jspb.Message.getFieldWithDefault(msg, 23, 0),
    categorycode: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.netty.server.im.protobuf.gencode.LoginMessage;
  return proto.com.netty.server.im.protobuf.gencode.LoginMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompanyid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBizcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsertoken(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 9:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (reader.readEnum());
      msg.setUsertype(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserip(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUseraddress(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsersource(value);
      break;
    case 14:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.ClientType} */ (reader.readEnum());
      msg.setClienttype(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientdetail(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessaddress(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBusinesslimit(value);
      break;
    case 18:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.ServiceStatus} */ (reader.readEnum());
      msg.setServicestatus(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSceneid(value);
      break;
    case 20:
      var value = msg.getSceneparamMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtend(value);
      break;
    case 22:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.SessionType} */ (reader.readEnum());
      msg.setSessiontype(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBizstep(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategorycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.netty.server.im.protobuf.gencode.LoginMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getBizcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustomerid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUsertoken();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUsertype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUserip();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUseraddress();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUsersource();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getClienttype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getClientdetail();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAccessaddress();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getBusinesslimit();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getServicestatus();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getSceneid();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getSceneparamMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(20, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getExtend();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getSessiontype();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getBizstep();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getCategorycode();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string sessionId = 1;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 companyId = 2;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setCompanyid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 userId = 3;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string bizCode = 4;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getBizcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setBizcode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account = 5;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string customerId = 6;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setCustomerid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string userToken = 7;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUsertoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUsertoken = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string name = 8;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional UserType userType = 9;
 * @return {!proto.com.netty.server.im.protobuf.gencode.UserType}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUsertype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.UserType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUsertype = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string locale = 10;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string userIp = 11;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUserip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUserip = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string userAddress = 12;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUseraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUseraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string userSource = 13;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getUsersource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setUsersource = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional ClientType clientType = 14;
 * @return {!proto.com.netty.server.im.protobuf.gencode.ClientType}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getClienttype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.ClientType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.ClientType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setClienttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string clientDetail = 15;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getClientdetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setClientdetail = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string accessAddress = 16;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getAccessaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setAccessaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional uint32 businessLimit = 17;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getBusinesslimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setBusinesslimit = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional ServiceStatus serviceStatus = 18;
 * @return {!proto.com.netty.server.im.protobuf.gencode.ServiceStatus}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getServicestatus = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.ServiceStatus} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.ServiceStatus} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setServicestatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional uint32 sceneId = 19;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getSceneid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setSceneid = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * map<string, string> sceneParam = 20;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getSceneparamMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 20, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.clearSceneparamMap = function() {
  this.getSceneparamMap().clear();
  return this;};


/**
 * optional string extend = 21;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getExtend = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setExtend = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional SessionType sessionType = 22;
 * @return {!proto.com.netty.server.im.protobuf.gencode.SessionType}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getSessiontype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.SessionType} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.SessionType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setSessiontype = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional uint32 bizStep = 23;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getBizstep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setBizstep = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string categoryCode = 24;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.getCategorycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.LoginMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.LoginMessage.prototype.setCategorycode = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.toObject = function(opt_includeInstance) {
  return proto.com.netty.server.im.protobuf.gencode.Knowledge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.netty.server.im.protobuf.gencode.Knowledge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    content: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.netty.server.im.protobuf.gencode.Knowledge;
  return proto.com.netty.server.im.protobuf.gencode.Knowledge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.netty.server.im.protobuf.gencode.Knowledge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.netty.server.im.protobuf.gencode.Knowledge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.netty.server.im.protobuf.gencode.Knowledge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge} returns this
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge} returns this
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content = 3;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge} returns this
 */
proto.com.netty.server.im.protobuf.gencode.Knowledge.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.repeatedFields_ = [28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.com.netty.server.im.protobuf.gencode.ChatMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bizcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    locale: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sessionid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usertoken: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clienttype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    messageid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    msgseq: jspb.Message.getFieldWithDefault(msg, 8, 0),
    from: jspb.Message.getFieldWithDefault(msg, 9, ""),
    fromtype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    fromaccount: jspb.Message.getFieldWithDefault(msg, 11, ""),
    frombizcode: jspb.Message.getFieldWithDefault(msg, 12, ""),
    fromcustomerid: jspb.Message.getFieldWithDefault(msg, 13, ""),
    fromname: jspb.Message.getFieldWithDefault(msg, 14, ""),
    to: jspb.Message.getFieldWithDefault(msg, 15, ""),
    totype: jspb.Message.getFieldWithDefault(msg, 16, 0),
    toaccount: jspb.Message.getFieldWithDefault(msg, 17, ""),
    tobizcode: jspb.Message.getFieldWithDefault(msg, 18, ""),
    tocustomerid: jspb.Message.getFieldWithDefault(msg, 19, ""),
    toname: jspb.Message.getFieldWithDefault(msg, 20, ""),
    content: jspb.Message.getFieldWithDefault(msg, 21, ""),
    receivetime: jspb.Message.getFieldWithDefault(msg, 22, ""),
    code: jspb.Message.getFieldWithDefault(msg, 23, 0),
    expose: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    sessiontype: jspb.Message.getFieldWithDefault(msg, 25, 0),
    messagetype: jspb.Message.getFieldWithDefault(msg, 26, 0),
    dataid: jspb.Message.getFieldWithDefault(msg, 27, 0),
    knowledgeList: jspb.Message.toObjectList(msg.getKnowledgeList(),
    proto.com.netty.server.im.protobuf.gencode.Knowledge.toObject, includeInstance),
    previousquestion: jspb.Message.getFieldWithDefault(msg, 29, ""),
    question: jspb.Message.getFieldWithDefault(msg, 30, ""),
    answer: jspb.Message.getFieldWithDefault(msg, 31, ""),
    evaluatetype: jspb.Message.getFieldWithDefault(msg, 32, 0),
    categorycode: jspb.Message.getFieldWithDefault(msg, 33, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.netty.server.im.protobuf.gencode.ChatMessage;
  return proto.com.netty.server.im.protobuf.gencode.ChatMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBizcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsertoken(value);
      break;
    case 6:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.ClientType} */ (reader.readEnum());
      msg.setClienttype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMsgseq(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 10:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (reader.readEnum());
      msg.setFromtype(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromaccount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrombizcode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromcustomerid(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromname(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    case 16:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (reader.readEnum());
      msg.setTotype(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setToaccount(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTobizcode(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTocustomerid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setToname(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivetime(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCode(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExpose(value);
      break;
    case 25:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.SessionType} */ (reader.readEnum());
      msg.setSessiontype(value);
      break;
    case 26:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.MessageType} */ (reader.readEnum());
      msg.setMessagetype(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDataid(value);
      break;
    case 28:
      var value = new proto.com.netty.server.im.protobuf.gencode.Knowledge;
      reader.readMessage(value,proto.com.netty.server.im.protobuf.gencode.Knowledge.deserializeBinaryFromReader);
      msg.addKnowledge(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousquestion(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswer(value);
      break;
    case 32:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.EvaluateType} */ (reader.readEnum());
      msg.setEvaluatetype(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategorycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.netty.server.im.protobuf.gencode.ChatMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getBizcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsertoken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClienttype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMsgseq();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFromtype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getFromaccount();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFrombizcode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getFromcustomerid();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFromname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTotype();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getToaccount();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTobizcode();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTocustomerid();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getToname();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getReceivetime();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getCode();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getExpose();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getSessiontype();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getMessagetype();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getDataid();
  if (f !== 0) {
    writer.writeUint32(
      27,
      f
    );
  }
  f = message.getKnowledgeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      proto.com.netty.server.im.protobuf.gencode.Knowledge.serializeBinaryToWriter
    );
  }
  f = message.getPreviousquestion();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAnswer();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getEvaluatetype();
  if (f !== 0.0) {
    writer.writeEnum(
      32,
      f
    );
  }
  f = message.getCategorycode();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
};


/**
 * optional uint32 companyId = 1;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setCompanyid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string bizCode = 2;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getBizcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setBizcode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string locale = 3;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sessionId = 4;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string userToken = 5;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getUsertoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setUsertoken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ClientType clientType = 6;
 * @return {!proto.com.netty.server.im.protobuf.gencode.ClientType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getClienttype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.ClientType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.ClientType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setClienttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string messageId = 7;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setMessageid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 msgSeq = 8;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getMsgseq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setMsgseq = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string from = 9;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional UserType fromType = 10;
 * @return {!proto.com.netty.server.im.protobuf.gencode.UserType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFromtype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.UserType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFromtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string fromAccount = 11;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFromaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFromaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string fromBizCode = 12;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFrombizcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFrombizcode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string fromCustomerId = 13;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFromcustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFromcustomerid = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string fromName = 14;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getFromname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setFromname = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string to = 15;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional UserType toType = 16;
 * @return {!proto.com.netty.server.im.protobuf.gencode.UserType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getTotype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.UserType} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.UserType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setTotype = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional string toAccount = 17;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getToaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setToaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string toBizCode = 18;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getTobizcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setTobizcode = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string toCustomerId = 19;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getTocustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setTocustomerid = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string toName = 20;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getToname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setToname = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string content = 21;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string receiveTime = 22;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getReceivetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setReceivetime = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional uint32 code = 23;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional bool expose = 24;
 * @return {boolean}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getExpose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setExpose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional SessionType sessionType = 25;
 * @return {!proto.com.netty.server.im.protobuf.gencode.SessionType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getSessiontype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.SessionType} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.SessionType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setSessiontype = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional MessageType messageType = 26;
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getMessagetype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.MessageType} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.MessageType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setMessagetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional uint32 dataId = 27;
 * @return {number}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getDataid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setDataid = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * repeated Knowledge knowledge = 28;
 * @return {!Array<!proto.com.netty.server.im.protobuf.gencode.Knowledge>}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getKnowledgeList = function() {
  return /** @type{!Array<!proto.com.netty.server.im.protobuf.gencode.Knowledge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.netty.server.im.protobuf.gencode.Knowledge, 28));
};


/**
 * @param {!Array<!proto.com.netty.server.im.protobuf.gencode.Knowledge>} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
*/
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setKnowledgeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.Knowledge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.netty.server.im.protobuf.gencode.Knowledge}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.addKnowledge = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.com.netty.server.im.protobuf.gencode.Knowledge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.clearKnowledgeList = function() {
  return this.setKnowledgeList([]);
};


/**
 * optional string previousQuestion = 29;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getPreviousquestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setPreviousquestion = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string question = 30;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string answer = 31;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional EvaluateType evaluateType = 32;
 * @return {!proto.com.netty.server.im.protobuf.gencode.EvaluateType}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getEvaluatetype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.EvaluateType} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.EvaluateType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setEvaluatetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 32, value);
};


/**
 * optional string categoryCode = 33;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.getCategorycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.ChatMessage} returns this
 */
proto.com.netty.server.im.protobuf.gencode.ChatMessage.prototype.setCategorycode = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.netty.server.im.protobuf.gencode.MessageData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.netty.server.im.protobuf.gencode.MessageData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messagedatatype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    loginmessage: (f = msg.getLoginmessage()) && proto.com.netty.server.im.protobuf.gencode.LoginMessage.toObject(includeInstance, f),
    chatmessage: (f = msg.getChatmessage()) && proto.com.netty.server.im.protobuf.gencode.ChatMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.netty.server.im.protobuf.gencode.MessageData;
  return proto.com.netty.server.im.protobuf.gencode.MessageData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.netty.server.im.protobuf.gencode.MessageData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {!proto.com.netty.server.im.protobuf.gencode.MessageDataType} */ (reader.readEnum());
      msg.setMessagedatatype(value);
      break;
    case 3:
      var value = new proto.com.netty.server.im.protobuf.gencode.LoginMessage;
      reader.readMessage(value,proto.com.netty.server.im.protobuf.gencode.LoginMessage.deserializeBinaryFromReader);
      msg.setLoginmessage(value);
      break;
    case 4:
      var value = new proto.com.netty.server.im.protobuf.gencode.ChatMessage;
      reader.readMessage(value,proto.com.netty.server.im.protobuf.gencode.ChatMessage.deserializeBinaryFromReader);
      msg.setChatmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.netty.server.im.protobuf.gencode.MessageData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.netty.server.im.protobuf.gencode.MessageData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessagedatatype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLoginmessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.netty.server.im.protobuf.gencode.LoginMessage.serializeBinaryToWriter
    );
  }
  f = message.getChatmessage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.netty.server.im.protobuf.gencode.ChatMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MessageDataType messageDataType = 2;
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageDataType}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.getMessagedatatype = function() {
  return /** @type {!proto.com.netty.server.im.protobuf.gencode.MessageDataType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.netty.server.im.protobuf.gencode.MessageDataType} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.setMessagedatatype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional LoginMessage LoginMessage = 3;
 * @return {?proto.com.netty.server.im.protobuf.gencode.LoginMessage}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.getLoginmessage = function() {
  return /** @type{?proto.com.netty.server.im.protobuf.gencode.LoginMessage} */ (
    jspb.Message.getWrapperField(this, proto.com.netty.server.im.protobuf.gencode.LoginMessage, 3));
};


/**
 * @param {?proto.com.netty.server.im.protobuf.gencode.LoginMessage|undefined} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
*/
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.setLoginmessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.clearLoginmessage = function() {
  return this.setLoginmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.hasLoginmessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ChatMessage chatMessage = 4;
 * @return {?proto.com.netty.server.im.protobuf.gencode.ChatMessage}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.getChatmessage = function() {
  return /** @type{?proto.com.netty.server.im.protobuf.gencode.ChatMessage} */ (
    jspb.Message.getWrapperField(this, proto.com.netty.server.im.protobuf.gencode.ChatMessage, 4));
};


/**
 * @param {?proto.com.netty.server.im.protobuf.gencode.ChatMessage|undefined} value
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
*/
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.setChatmessage = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.netty.server.im.protobuf.gencode.MessageData} returns this
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.clearChatmessage = function() {
  return this.setChatmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.netty.server.im.protobuf.gencode.MessageData.prototype.hasChatmessage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.MessageDataType = {
  CLIENT_LOGIN: 0,
  SERVER_ERROR: 1,
  CLIENT_PING: 2,
  SERVER_PONG: 3,
  USER_SINGLE: 4,
  SERVICE_SINGLE: 5,
  SERVICE_ALL: 6,
  SERVICE_STATUS_UPDATE: 7,
  USER_WAIT_CONNECT: 8,
  USER_CONNECT: 9,
  USER_CONNECT_FAIL: 10,
  USER_ONLINE: 11,
  USER_OFFLINE: 12,
  USER_FORCE_OFFLINE: 13,
  USER_MESSAGE_READ: 14,
  SERVICE_ONLINE: 15,
  SERVICE_OFFLINE: 16,
  SERVICE_UPDATE: 17,
  SERVICE_REPLY_USER: 18,
  SERVICE_CONNECT_BUTTON: 19,
  SERVICE_CONNECT_ALL_BUTTON: 20,
  SERVICE_LIST_PG_BUTTON: 21,
  SERVICE_SEND_SESSION_BUTTON: 22,
  SERVICE_SEND_SESSION_NOTICE: 23,
  SERVICE_RECEIVE_SESSION_BUTTON: 24,
  SERVICE_RECEIVE_SESSION_NOTICE: 25,
  SERVICE_REJECT_SESSION_BUTTON: 26,
  SERVICE_REJECT_SESSION_NOTICE: 27,
  SERVICE_UPDATE_USER_BUTTON: 28,
  SERVICE_FINISH_SESSION_BUTTON: 29,
  SERVICE_FINISH_SESSION_NOTICE: 30,
  SERVICE_FIX: 31,
  SERVICE_SINGLE_MESSAGE_READ: 32,
  SHUT_DOWN_PREVIOUS_SESSION: 33,
  SESSION_AUTO_FINISH_NOTICE: 34,
  SERVICE_MONITOR_SESSION_UPDATE_NOTICE: 35,
  SESSION_ROBOT_TO_MANUAL: 36,
  SERVICE_CONNECT_WAIT_ASSIGN_BUTTON: 37,
  SERVICE_CONNECT_WAIT_ASSIGN_NOTICE: 38,
  USER_WAIT_ONLINE: 39,
  USER_WAIT_OFFLINE: 40,
  USER_ACQUIRE_SERVICE: 41,
  USER_ACQUIRE_SERVICE_FAIL: 42,
  SERVICE_ROBOT_MESSAGE: 43,
  USER_INPUT_MESSAGE: 44,
  USER_CHANGE_CATEGORY: 45,
  USER_EVALUATE: 46,
  SERVICE_INPUT_MESSAGE: 47
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.ClientType = {
  M_CLIENT: 0,
  PC_CLIENT: 1,
  APP_CLIENT: 2
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.UserType = {
  CUSTOMER_USER: 0,
  SIMULATE_USER: 1,
  N_USER: 2,
  A_USER: 3,
  SERVICE_USER: 4,
  ROBOT_USER: 5
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.ServiceStatus = {
  ONLINE: 0,
  BUSY: 1,
  OFFLINE: 2
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.SessionType = {
  ROBOT: 0,
  MANUAL: 1
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.MessageType = {
  NORMAL_MESSAGE: 0,
  ROBOT_WELCOME: 1,
  ROBOT_ANSWER: 2,
  COMMON_WELCOME: 3,
  PRIVATE_WELCOME: 4,
  SCENE_WELCOME: 5,
  ACQUIRE_SERVICE: 6,
  ROBOT_NO_ANSWER: 7,
  ACQUIRE_SERVICE_FAIL: 8,
  ROBOT_RECOMMEND: 9,
  ROBOT_PRESET_ANSWER: 10,
  PRIVATE_AUTO_ANSWER: 11,
  ROBOT_CATEGORY: 12,
  ROBOT_USER_EVALUATE: 13,
  ROBOT_USER_EVALUATE_ANSWER: 14
};

/**
 * @enum {number}
 */
proto.com.netty.server.im.protobuf.gencode.EvaluateType = {
  NOT_COMMENT: 0,
  USEFUL: 1,
  USELESS: 2
};

goog.object.extend(exports, proto.com.netty.server.im.protobuf.gencode);
